import React from 'react';
import useFieldHelper from '../fieldHelper';
import { BaseFieldLayoutType, FieldProps } from '../types';
// services
import { useUiTheme } from 'framework/uiTheme';
import { getWithThousandsSeparator } from '../../../utils/strings/amountUtils';

const AmountField = (props: FieldProps<number>) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const initialValue = getValue();

  const amount = initialValue && getWithThousandsSeparator(initialValue);

  return <BaseFieldLayout label={getLabel()} value={amount} />;
};

export default AmountField;
